// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset y estilos globales */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    overflow-x: hidden;
    background-color: var(--gb-lightest);
}

.portfolio {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    z-index: 1;
}

/* Scrollbar personalizado estilo Game Boy */
::-webkit-scrollbar {
    width: 12px;
}

::-webkit-scrollbar-track {
    background: var(--gb-lightest);
    border: 2px solid var(--gb-darkest);
}

::-webkit-scrollbar-thumb {
    background: var(--gb-dark);
    border: 2px solid var(--gb-darkest);
}

::-webkit-scrollbar-thumb:hover {
    background: var(--gb-accent);
}

/* Selección de texto */
::selection {
    background-color: var(--gb-accent);
    color: var(--gb-darkest);
}

/* Animación de carga */
@keyframes pixelate {
    0% { opacity: 0; transform: scale(0.8); }
    100% { opacity: 1; transform: scale(1); }
}

section {
    animation: pixelate 0.5s ease-in-out;
}

/* Control de música - contenedor */
.music-control {
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 1000;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 10px;
}

/* Botón de música - estilo 8-bit */
.music-toggle {
    width: 50px;
    height: 50px;
    background-color: var(--gb-light);
    border: 4px solid var(--gb-accent);
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease-in;
    padding: 8px;
}

.music-icon {
    width: 100%;
    height: 100%;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    object-fit: contain;
}

.music-toggle:hover {
    background-color: var(--gb-accent);
    transform: scale(1.1);
    box-shadow: 4px 8px 0 rgba(0, 0, 0, 0.3);
}

.music-toggle:active {
    transform: scale(0.95);
    box-shadow: 2px 4px 0 rgba(0, 0, 0, 0.3);
}

/* Control de volumen */
.volume-control {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background-color: var(--gb-darkest);
    border: 4px solid var(--gb-accent);
    padding: 15px;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);
    animation: slideInFromRight 0.3s ease-out;
}

@keyframes slideInFromRight {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.volume-slider {
    -webkit-appearance: none;
    width: 150px;
    height: 8px;
    background: var(--gb-light);
    border: 2px solid var(--gb-darkest);
    outline: none;
    cursor: pointer;
}

.volume-slider::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    background: var(--gb-accent);
    border: 2px solid var(--gb-darkest);
    cursor: pointer;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}

.volume-slider::-webkit-slider-thumb:hover {
    background: var(--gb-lightest);
    transform: scale(1.2);
}

.volume-slider::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: var(--gb-accent);
    border: 2px solid var(--gb-darkest);
    cursor: pointer;
    -moz-transition: all 0.2s;
    transition: all 0.2s;
}

.volume-slider::-moz-range-thumb:hover {
    background: var(--gb-lightest);
    transform: scale(1.2);
}

.volume-value {
    color: var(--gb-lightest);
    font-family: 'Press Start 2P', cursive;
    font-size: 10px;
}

/* Botón de scroll to top - estilo 8-bit */
.scroll-to-top {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 50px;
    height: 50px;
    background-color: var(--gb-light);
    border: 4px solid var(--gb-accent);
    color: var(--gb-lightest);
    font-size: 20px;
    font-family: 'Press Start 2P', cursive;
    cursor: pointer;
    z-index: 1000;
    transition: all 0.3s ease;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);
    animation: fadeIn 0.3s ease-in;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scroll-to-top:hover {
    background-color: var(--gb-accent);
    color: var(--gb-darkest);
    transform: translateY(-5px);
    box-shadow: 4px 8px 0 rgba(0, 0, 0, 0.3);
}

.scroll-to-top:active {
    transform: translateY(-3px) scale(0.95);
    box-shadow: 2px 4px 0 rgba(0, 0, 0, 0.3);
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive */
@media (max-width: 768px) {
    .music-control {
        top: 20px;
        right: 20px;
    }
    
    .music-toggle {
        width: 45px;
        height: 45px;
    }
    
    .volume-control {
        padding: 10px;
    }
    
    .volume-slider {
        width: 100px;
    }
    
    .scroll-to-top {
        bottom: 20px;
        right: 20px;
        width: 45px;
        height: 45px;
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,UAAU;AACd;;AAEA,4CAA4C;AAC5C;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,uBAAuB;AACvB;IACI,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA,uBAAuB;AACvB;IACI,KAAK,UAAU,EAAE,qBAAqB,EAAE;IACxC,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA,mCAAmC;AACnC;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;AACb;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kCAAkC;IAClC,eAAe;IACf,yBAAyB;IACzB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mCAAmC;IACnC,kCAAkC;IAClC,aAAa;IACb,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,mCAAmC;IACnC,aAAa;IACb,eAAe;AACnB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,mCAAmC;IACnC,eAAe;IACf,4BAAoB;IAApB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,mCAAmC;IACnC,eAAe;IACf,yBAAoB;IAApB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;IACtC,eAAe;AACnB;;AAEA,0CAA0C;AAC1C;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,wCAAwC;IACxC,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,eAAe;AACf;IACI;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":["/* Reset y estilos globales */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nbody {\n    overflow-x: hidden;\n    background-color: var(--gb-lightest);\n}\n\n.portfolio {\n    position: relative;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    z-index: 1;\n}\n\n/* Scrollbar personalizado estilo Game Boy */\n::-webkit-scrollbar {\n    width: 12px;\n}\n\n::-webkit-scrollbar-track {\n    background: var(--gb-lightest);\n    border: 2px solid var(--gb-darkest);\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--gb-dark);\n    border: 2px solid var(--gb-darkest);\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: var(--gb-accent);\n}\n\n/* Selección de texto */\n::selection {\n    background-color: var(--gb-accent);\n    color: var(--gb-darkest);\n}\n\n/* Animación de carga */\n@keyframes pixelate {\n    0% { opacity: 0; transform: scale(0.8); }\n    100% { opacity: 1; transform: scale(1); }\n}\n\nsection {\n    animation: pixelate 0.5s ease-in-out;\n}\n\n/* Control de música - contenedor */\n.music-control {\n    position: fixed;\n    top: 30px;\n    right: 30px;\n    z-index: 1000;\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n    gap: 10px;\n}\n\n/* Botón de música - estilo 8-bit */\n.music-toggle {\n    width: 50px;\n    height: 50px;\n    background-color: var(--gb-light);\n    border: 4px solid var(--gb-accent);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    animation: fadeIn 0.3s ease-in;\n    padding: 8px;\n}\n\n.music-icon {\n    width: 100%;\n    height: 100%;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n    object-fit: contain;\n}\n\n.music-toggle:hover {\n    background-color: var(--gb-accent);\n    transform: scale(1.1);\n    box-shadow: 4px 8px 0 rgba(0, 0, 0, 0.3);\n}\n\n.music-toggle:active {\n    transform: scale(0.95);\n    box-shadow: 2px 4px 0 rgba(0, 0, 0, 0.3);\n}\n\n/* Control de volumen */\n.volume-control {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    background-color: var(--gb-darkest);\n    border: 4px solid var(--gb-accent);\n    padding: 15px;\n    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);\n    animation: slideInFromRight 0.3s ease-out;\n}\n\n@keyframes slideInFromRight {\n    from {\n        opacity: 0;\n        transform: translateX(-20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.volume-slider {\n    -webkit-appearance: none;\n    width: 150px;\n    height: 8px;\n    background: var(--gb-light);\n    border: 2px solid var(--gb-darkest);\n    outline: none;\n    cursor: pointer;\n}\n\n.volume-slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 20px;\n    height: 20px;\n    background: var(--gb-accent);\n    border: 2px solid var(--gb-darkest);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.volume-slider::-webkit-slider-thumb:hover {\n    background: var(--gb-lightest);\n    transform: scale(1.2);\n}\n\n.volume-slider::-moz-range-thumb {\n    width: 20px;\n    height: 20px;\n    background: var(--gb-accent);\n    border: 2px solid var(--gb-darkest);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.volume-slider::-moz-range-thumb:hover {\n    background: var(--gb-lightest);\n    transform: scale(1.2);\n}\n\n.volume-value {\n    color: var(--gb-lightest);\n    font-family: 'Press Start 2P', cursive;\n    font-size: 10px;\n}\n\n/* Botón de scroll to top - estilo 8-bit */\n.scroll-to-top {\n    position: fixed;\n    bottom: 30px;\n    right: 30px;\n    width: 50px;\n    height: 50px;\n    background-color: var(--gb-light);\n    border: 4px solid var(--gb-accent);\n    color: var(--gb-lightest);\n    font-size: 20px;\n    font-family: 'Press Start 2P', cursive;\n    cursor: pointer;\n    z-index: 1000;\n    transition: all 0.3s ease;\n    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.3);\n    animation: fadeIn 0.3s ease-in;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scroll-to-top:hover {\n    background-color: var(--gb-accent);\n    color: var(--gb-darkest);\n    transform: translateY(-5px);\n    box-shadow: 4px 8px 0 rgba(0, 0, 0, 0.3);\n}\n\n.scroll-to-top:active {\n    transform: translateY(-3px) scale(0.95);\n    box-shadow: 2px 4px 0 rgba(0, 0, 0, 0.3);\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .music-control {\n        top: 20px;\n        right: 20px;\n    }\n    \n    .music-toggle {\n        width: 45px;\n        height: 45px;\n    }\n    \n    .volume-control {\n        padding: 10px;\n    }\n    \n    .volume-slider {\n        width: 100px;\n    }\n    \n    .scroll-to-top {\n        bottom: 20px;\n        right: 20px;\n        width: 45px;\n        height: 45px;\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
